"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _animate = require("./animate");

var _style = require("../utils/style");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    &:before {\n      content: '';\n      width:", ";\n      height: 5px;\n      background: #000;\n      opacity: 0.1;\n      position: absolute;\n      top: calc(", " + 10px) ;\n      left: 0;\n      border-radius: 50%;\n      animation: ", " ", "s linear infinite;\n    }\n    &:after {\n      content: '';\n      width: ", ";\n      height:", ";\n      background: ", ";\n      animation: ", " ", "s linear infinite;\n      position: absolute;\n      top: 0;\n      left: 0;\n      border-radius: 3px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var LoadContainer = _styledComponents.default.div(_templateObject(), function (props) {
  return _style.sizeContainer[props.size] || _style.sizeContainer['default'];
}, function (props) {
  return _style.sizeContainer[props.size] || _style.sizeContainer['default'];
}, function (props) {
  return _style.sizeContainer[props.size] || _style.sizeContainer['default'];
}, function (props) {
  return _style.sizeContainer[props.size] || _style.sizeContainer['default'];
}, _animate.animate, function (props) {
  return props.speed || 0.5;
}, function (props) {
  return _style.sizeContainer[props.size] || _style.sizeContainer['default'];
}, function (props) {
  return _style.sizeContainer[props.size] || _style.sizeContainer['default'];
}, function (props) {
  return props.color || '#00adb5';
}, _animate.shadow, function (props) {
  return props.speed || 0.5;
});

var BoxLoading = function BoxLoading(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? _style.commonStyle : _ref$style,
      color = _ref.color,
      speed = _ref.speed,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "default" : _ref$size;
  return _react.default.createElement(LoadContainer, {
    style: style,
    color: color,
    speed: speed,
    size: size
  });
};

var _default = BoxLoading;
exports.default = _default;